import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import "src/assets/css/styles.css";
import "src/assets/css/style.css";
import "src/assets/css/base.css";
import "src/assets/css/analysis.css";
import "src/custom.css";
import "src/assets/css/changeplan.css"
import "src/assets/css/alert.css"
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  BarElement,
  CategoryScale,
  Filler,
  Tooltip,
  Legend,
  ArcElement,
  LinearScale,
} from 'chart.js';
import { DI } from "./base/Injector";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  BarElement,
  Filler,
  Tooltip,
  Legend,
  CategoryScale,
  ArcElement,
  LinearScale,
  ChartDataLabels
);

DI.get().injectAuthDependencies()
DI.get().injectAccountDependencies()
DI.get().injectUnsharedFilesDependencies()
DI.get().injectOrthodontistDependencies()
DI.get().injectPatientDependencies()
DI.get().injectMedicalRecordDependencies()
DI.get().injectAnalyticDependencies()

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
